"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throttle = void 0;

/**
 * Call a function only if it hasn't been called in the last `timeWindow` ms.
 *
 * @param  {function} fn            Function to be ran
 * @param  {integer}  timeWindow    Time between each `fn` call
 *
 * @return {function}               Either return `fn` if you've passed the
 *                                  `timeWindow` or return a timer that will
 *                                  run the `fn` in `timeWindow` ms
 */
var throttle = function throttle(fn) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$timeWindow = _ref.timeWindow,
      timeWindow = _ref$timeWindow === void 0 ? 50 : _ref$timeWindow,
      _ref$bind = _ref.bind,
      bind = _ref$bind === void 0 ? null : _ref$bind,
      _ref$hasLastCall = _ref.hasLastCall,
      hasLastCall = _ref$hasLastCall === void 0 ? false : _ref$hasLastCall;

  var lastExecution = new Date(new Date().getTime() - timeWindow);
  var finalRunTimer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var hasTimeWindowPassed = lastExecution.getTime() + timeWindow <= new Date().getTime();

    if (hasTimeWindowPassed) {
      lastExecution = new Date();
      fn.apply(bind, args);
    }

    if (hasLastCall) {
      // reset timer at every function call
      clearTimeout(finalRunTimer);
      finalRunTimer = setTimeout(function () {
        lastExecution = new Date();
        fn.apply(bind, args);
      }, timeWindow);
    }
  };
};

exports.throttle = throttle;